import { useCheckout, usePassportProvider } from "@/context";
import * as checkout from "@imtbl/checkout-sdk";
import { useEffect, useState } from "react";

export const CommerceWidget = ({
  params,
  onClose,
  onSuccess,
  onFailure,
}: {
  params: checkout.CommerceWidgetParams;
  onClose: () => void;
  onSuccess: (event: checkout.CommerceSuccessEvent) => void;
  onFailure: (event: checkout.CommerceFailureEvent) => void;
}) => {
  const [commerceWidget, setCommerceWidget] =
    useState<checkout.Widget<typeof checkout.WidgetType.IMMUTABLE_COMMERCE>>();

  const { passportClient } = usePassportProvider();
  const { checkoutClient: checkoutSDK } = useCheckout();

  useEffect(() => {
    (async () => {
      const widgetsFactory = await checkoutSDK.widgets({
        config: {
          theme: checkout.WidgetTheme.DARK,
        },
      });

      const commerceWidget = widgetsFactory.create(
        checkout.WidgetType.IMMUTABLE_COMMERCE,
        {
          provider: new checkout.WrappedBrowserProvider(
            await passportClient.connectEvm(),
          ),
        },
      );
      setCommerceWidget(commerceWidget);
    })();
  }, [passportClient, checkoutSDK]);

  useEffect(() => {
    if (!commerceWidget) return;
    commerceWidget.mount("no-thanks", params);
    commerceWidget.addListener(checkout.CommerceEventType.CLOSE, onClose);
    commerceWidget.addListener(checkout.CommerceEventType.SUCCESS, onSuccess);
    commerceWidget.addListener(checkout.CommerceEventType.FAILURE, onFailure);
    return () => {
      commerceWidget.removeListener(checkout.CommerceEventType.SUCCESS);
      commerceWidget.removeListener(checkout.CommerceEventType.CLOSE);
      commerceWidget.removeListener(checkout.CommerceEventType.FAILURE);
      commerceWidget.unmount();
    };
  }, [params, onClose, onSuccess, onFailure, commerceWidget]);

  return <div id="no-thanks" />;
};
